import { useDataChange, useDataValue } from 'Simple/Data.js'

export function isSelected(id, answer) {
  return Array.isArray(answer) && answer.map(item => item.id).includes(id)
}

export function useOnClick(props) {
  let question_option_text = useDataValue({
    context: 'question_option',
    path: 'text',
    viewPath: props.viewPath,
  })

  let rvalue = useDataValue({
    viewPath: props.viewPath,
    context: 'question',
    path: 'answer',
  })

  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'question',
    path: 'answer',
  })

  return function onClick(clickValue) {
    let value = Array.isArray(rvalue) ? [...rvalue] : []

    let ids = value.map(item => item.id)

    if (ids.includes(clickValue)) {
      value = value.filter(item => item.id !== clickValue)
    } else {
      value.push({
        id: clickValue,
        text: question_option_text,
        displayValues: ['text'],
      })
    }

    change(value)
  }
}

export function populateTemplate(questions, template, values) {
  if (!template) return template

  let re = /\{\{(.+?)\}\}/gim
  let output = template

  try {
    let t = [...template.matchAll(re)]
    t.forEach(item => {
      output = output.replaceAll(
        item[0],
        values[item[1]] ||
          values[
            questions.find(question => question?.resource_id === item[1])?.id
          ]
      )
    })
  } catch (_) {}

  return output
}
